import { useEffect } from "react";

import {
    useExperimentExposure,
    experiments
} from "@/utils/experiment/index.ts";

import {
    UniformEntryPage,
    UniformEntryPageProps
} from "./uniform-entry-page.tsx";

export const UniformConfluencePricingEntryPage = (
    props: UniformEntryPageProps
) => {
    const [hasFired, fireExposure] = useExperimentExposure(
        experiments.confluencePricingPageWaeMigration
    );

    // this is the existing experiment in the confluence pricing page
    // services/wac-web/src/pages/software/confluence/pricing/confluence-pricing-page.tsx
    const [
        pricingDirectBuyCheckoutFired,
        pricingDirectBuyCheckoutFireExposure
    ] = useExperimentExposure(experiments.pricingDirectBuyCheckout);

    useEffect(() => {
        if (!pricingDirectBuyCheckoutFired) {
            pricingDirectBuyCheckoutFireExposure();
        }
    }, [pricingDirectBuyCheckoutFired, pricingDirectBuyCheckoutFireExposure]);

    useEffect(() => {
        if (!hasFired) {
            fireExposure();
        }
    }, [hasFired, fireExposure]);

    return <UniformEntryPage {...props} />;
};
